import { TrashState } from './models';
import { DEFAULT_PER_PAGE } from '@helpers/constants';

export const defaultState: TrashState = {
  files: {
    tdos: {},
    selectedItems: [],
    selectedTdos: {},
    isFetchingData: false,
    pageSize: DEFAULT_PER_PAGE,
    pageIndex: 0,
    hasNextPage: false,
  },
  folders: {
    folders: {},
    selectedItems: [],
    selectedFolders: {},
    isFetchingData: false,
    pageSize: DEFAULT_PER_PAGE,
    pageIndex: 0,
    hasNextPage: false,
    caseFiles: {},
  },
};

export const namespace = 'vtn-redact-state-trash';

export interface TrashStore {
  [namespace]: TrashState;
}
